<template>
  <!-- NOTE (TEMPLATE) to show the reviewer page -->

  <div class="animated fadeIn" v-if="isLoaded">
    <span v-show="false">{{ reactivity }}</span>
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path.indexOf('/admin/reviewer') == 0"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>
        {{ profile.name + " " + profile.lastName }} ({{ profile.status }})
      </h2>
      <hr />
      <b-tabs pills>
        <b-tab title="اطلاعات عمومی" active>
          <b-form-group label="تلفن همراه">
            <b-form-input
              trim
              type="number"
              :no-wheel="true"
              v-model="profile.mobile"
              disabled
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام">
            <b-form-input
              trim
              type="text"
              v-model="profile.name"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام خانوادگی">
            <b-form-input
              trim
              type="text"
              v-model="profile.lastName"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="پست الکترونیکی">
            <b-form-input
              trim
              type="text"
              v-model="profile.email"
              :state="validateEmail(profile.email) ? null : false"
              aria-describedby="email"
            ></b-form-input>
            <b-form-invalid-feedback id="email"
              >پست الکترونیک صحیح نیست</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group description label="استان:">
            <v-autocomplete
              v-model="profile.stateId"
              :items="iran"
              @change="profile.cityId = ''"
              item-value="id"
              item-text="name"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>

          <b-form-group description label="شهر:">
            <v-autocomplete
              v-model="profile.cityId"
              :items="
                iran
                  .filter((x) => x.id == profile.stateId)
                  .map((y) => y.cities)[0]
              "
              item-value="id"
              item-text="name"
              dense
              outlined
              class="dropdown-style"
              hide-details
            ></v-autocomplete>
          </b-form-group>
          <b-row class="mb-2">
            <b-col>
              <span class="select-text">دانشگاه </span>
            </b-col>
            <b-col class="text-left">
              <b-form-checkbox
                id="checkbox-1"
                v-model="profile.universityId"
                name="checkbox-1"
                value="1"
                unchecked-value=""
                @change="reactivity = !reactivity"
              >
                سایر دانشگاه ها
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form-group style="width: 100%">
            <v-autocomplete
              v-model="profile.universityId"
              :items="universityList"
              item-value="id"
              item-text="text"
              dense
              outlined
              class="dropdown-style"
              hide-details
              :disabled="profile.universityId == 1"
            ></v-autocomplete>
            <b-form-input
              trim
              class="mt-3"
              v-model="profile.otherUniversity"
              v-show="profile.universityId == 1"
              placeholder="نام دانشگاه مورد نظر"
              @input="reactivity = !reactivity"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="رشته تحصیلی">
            <b-form-input
              trim
              type="text"
              v-model="profile.field"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="کدملی">
            <b-form-input
              trim
              type="number"
              v-model="profile.natCode"
              :state="checkCodeMeli(profile.natCode) ? null : false"
              aria-describedby="natCode"
            ></b-form-input>
            <b-form-invalid-feedback id="natCode"
              >کد ملی درست نیست</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label="آخرین مدرک تحصیلی">
            <b-form-select
              v-model="profile.lastDegree"
              :options="eduGradeOptions"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="برچسب‌های داور">
            <b-form-tags
              tag-variant="primary"
              tag-pills
              placeholder="برچسب اضافه کنید"
              input-id="tags-basic"
              addButtonText="افزودن"
              v-model="profile.tags"
            ></b-form-tags>
          </b-form-group>
          <b-form-group label="وضعیت کاربر">
            <b-form-select
              v-model="profile.status"
              :options="states"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label="توضیحات تغییر وضعیت"
            v-if="profile.status == 'نیازمند به تکمیل'"
          >
            <b-form-textarea
              trim
              v-model="profile.adminMessage"
              type="text"
              rows="6"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>

          <div class="d-flex">
            <!-- NOTE (b-editReviewer) to submit reviewer changes -->
            <v-btn class="mx-2 green-btn" @click="editReviewer()">
              <v-icon class="me-2">mdi-check</v-icon>
              ثبت تغییرات
            </v-btn>
          </div>
        </b-tab>
        <b-tab title="داوری‌ها">
          <!-- NOTE (t-judgments) to show the judgments list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields"
            :items="items"
            :current-page="currentPage"
            :per-page="perPage"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="fileBusy"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(status)="data">
              <div style="text-align: center; vertical-align: middle">
                {{
                  data.value == "Done"
                    ? "تمام"
                    : data.value == "NotDone"
                    ? "ناتمام"
                    : "منقضی"
                }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (<a>) to show the proposal details -->
                <a
                  v-if="data.item.requestType == 'طرح پژوهشی'"
                  :href="'/admin/proposal/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'رساله دکتری'"
                  :href="'/admin/phdProposal/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'پایان نامه کارشناسی ارشد'"
                  :href="'/admin/masterProposal/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'پسادکتری'"
                  :href="'/admin/postDoc/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'مقاله'"
                  :href="'/admin/article/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >

                <a
                  v-if="data.item.requestType == 'فرصت مطالعاتی'"
                  :href="'/admin/opportunity/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'نشست تخصصی'"
                  :href="'/admin/meeting/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
                <a
                  v-if="data.item.requestType == 'نخبگان وظیفه'"
                  :href="'/admin/Elite/' + data.item.id"
                  target="_blank"
                  class="btn btn-primary text-light"
                  style="width: 100%"
                  >جزییات</a
                >
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="ویرایش رمز">
          <h3>ویرایش رمز داور</h3>
          <b-form-group label="رمز جدید">
            <b-form-input
              v-model="password"
              type="password"
              autocomplete="new-password"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="تکرار رمز جدید">
            <b-form-input
              v-model="repeatPassord"
              type="password"
            ></b-form-input>
          </b-form-group>
          <v-btn
            class="blue-btn"
            @click="resetPass()"
            :disabled="busy || !password || !repeatPassord"
            >ویرایش رمز</v-btn
          >
        </b-tab>
      </b-tabs>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import utilities from "../../mixins/utilities"; // REVIEW
import md5 from "js-md5";

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  mixins: [utilities], // REVIEW
  data() {
    return {
      reactivity: false,
      otherUniversity: "",
      perPage: 10,
      currentPage: 1,
      iran: [],
      totalRows: 1,
      profile: {},
      eduGradeOptions: ["کارشناسی", "کارشناسی ارشد", "دکتری", "دکتری حرفه ای"],
      isLoaded: true,
      universityList: [],
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      states: [
        { value: "فعال", eng: "active", text: "فعال" },
        { value: "غیرفعال", eng: "deactive", text: "غیرفعال" },
      ],
      fileBusy: true,
      fileFilter: "",
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "judgeCode", label: "کد داوری" },
        { key: "finalComment", label: "توضیحات" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      filter: "",
      isBusy: true,
      password: "",
      repeatPassord: "",
      busy: false,
    };
  },

  methods: {
    resetPass() {
      if (this.password == this.repeatPassord) {
        this.busy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/admin/reviewer/resetPassword",
            {
              refereeId: this.$route.params.id,
              password: md5(this.password),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.busy = false;
            if (res.status == 200) {
              this.toast(res.data, "success");
              this.password = "";
              this.repeatPassord = "";
            }
          })
          .catch((err) => {
            this.busy = false;
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403) {
              if (err.response.data == "expired")
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
              else
                this.$router.push({
                  path: "/login",
                  query: { return: window.location.pathname },
                });
            }
          });
      } else {
        this.toast("رمز جدید با تکرار آن مطابقت ندارد", "error");
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editReviewer() {
      if (this.validateEmail(this.profile.email) || this.profile.email == "") {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.$bvModal.show("loading");
          this.isLoaded = false;
          // NOTE (m-editReviewer) to edit the reviewer profile
          this.$http
            .post(
              this.baseUrl + "/setad/admin/reviewer/edit",
              {
                refereeId: this.$route.params.id,
                name: this.profile.name,
                lastName: this.profile.lastName,
                lastDegree: this.profile.lastDegree,
                email: this.profile.email,
                stateId: this.profile.stateId
                  ? this.profile.stateId
                  : null,
                cityId: this.profile.cityId ? this.profile.cityId : null,
                tags: this.profile.tags,
                status: this.states.filter(
                  (x) => x.value == this.profile.status
                )[0].eng,
                field: this.profile.field,
                universityId: this.profile.universityId,
                otherUniversity:
                  this.profile.universityId == this.notUniversity
                    ? this.profile.otherUniversity
                    : "",
                natCode: this.profile.natCode,
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("userId"),
                },
              }
            )
            .then((res) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              if (res.status == 200) {
                this.toast(res.data, "success");
                this.update();
              }
            })
            .catch((err) => {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              console.log(err);
              this.toast(err.response.data, "error");
              if (err.response.status == 403) {
                if (err.response.data == "expired")
                  this.$router.push({
                    path: "/login",
                    query: { return: window.location.pathname },
                  });
                // else this.$router.replace("/unauthorize");
                else
                  this.$router.push({
                    path: "/login",
                    query: { return: window.location.pathname },
                  });
              }
            });
        } else {
          this.toast("کدملی وارد شده صحیح نمی باشد", "error");
        }
      } else {
        if (
          this.checkCodeMeli(this.profile.natCode) ||
          this.profile.natCode == ""
        ) {
          this.toast("پست الکترونیکی وارد شده صحیح نمی باشد", "error");
        } else {
          this.toast("کدملی و پست الکترونیکی وارد شده صحیح نمی باشند", "error");
        }
      }
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of reviewer page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.fileBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universityList = res.data;
          this.universityList.push(
            new Object({
              id: 1,
              text: "سایر دانشگاه ها",
            })
          );
          this.universityList.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewer/getInfo",
          {
            refereeId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.profile = res.data.referee;
          this.items = res.data.reviews;
          this.fileBusy = false;
          this.totalRows = this.items.length;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/options/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    update() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reviewer/getInfo",
          {
            refereeId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.profile = res.data.referee;
          this.items = res.data.reviews;
          this.fileBusy = false;
          this.totalRows = this.items.length;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.isBusy = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;

          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },

  mounted() {
    this.getStatesAndCities();
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
